"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueSchema = exports.MetricTargetSchema = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.MetricTargetSchema = (0, yup_1.object)({
    metricName: (0, yup_1.mixed)().required(),
    alert: (0, yup_1.number)().notRequired(),
    warning: (0, yup_1.number)().notRequired(),
    target: (0, yup_1.number)().notRequired(),
    lowerIsBetter: (0, yup_1.boolean)().default(true),
    percentageOf: (0, yup_1.mixed)().notRequired(),
});
exports.QueueSchema = model_schema_1.Schema.shape({
    InstanceId: (0, yup_1.string)().required(),
    companyID: (0, yup_1.string)().required(),
    queueLimitSeconds: (0, yup_1.number)().notRequired(),
    facia: (0, yup_1.string)().notRequired(),
    greetingMessage: (0, yup_1.string)().notRequired(),
    queueType: (0, yup_1.string)().notRequired(),
    languageCode: (0, yup_1.string)().notRequired(),
    name: (0, yup_1.string)().notRequired(),
    tryOutSource: (0, yup_1.boolean)().notRequired(),
    outSourceQueueARN: (0, yup_1.string)().notRequired(),
    outSourceNumber: (0, yup_1.string)().notRequired(),
    metricTargets: (0, yup_1.array)(exports.MetricTargetSchema)
        .notRequired()
        .default(undefined),
    slaSeconds: (0, yup_1.number)().notRequired(),
    slaByAbandoned: (0, yup_1.boolean)().notRequired(),
    slaByAnswered: (0, yup_1.boolean)().notRequired(),
    shortAbandonedSeconds: (0, yup_1.number)().notRequired(),
});
// interface IQueue extends IModel {
//     InstanceId: string;
//     companyID: string;
//     queueLimitSeconds?: number;
//     facia?: string;
//     greetingMessage?: string;
//     queueType?: string;
//     languageCode?: string;
//     name?: string;
//     tryOutSource?: boolean;
//     outSourceQueueARN?: string;
//     outSourceNumber?: string;
// }
